// extracted by mini-css-extract-plugin
export default {"grid":"rqnz7Y6JRZUTi2GNOiwUHA==","grid_column":"ju81wZB25nRtNDl5V8J0jg=="};